import {http} from '@/http'

// DEF-ADM-021 — Liquidaciones a proveedores.
// La ciudad la agrega el interceptor con el header X-City-Id.
export default {
  list(params) {
    return http.get('/api/v1/settlements', {params})
  },
  get(id) {
    return http.get(`/api/v1/settlements/${id}`)
  },
  // Sin fechas, el backend sugiere el período según la frecuencia del proveedor.
  create(data) {
    return http.post('/api/v1/settlements', data)
  },
  // Solo en DRAFT: deducciones y notas.
  update(id, data) {
    return http.put(`/api/v1/settlements/${id}`, data)
  },
  delete(id) {
    return http.delete(`/api/v1/settlements/${id}`)
  },
  send(id) {
    return http.post(`/api/v1/settlements/${id}/send`)
  },
  returnToDraft(id) {
    return http.post(`/api/v1/settlements/${id}/return-to-draft`)
  },
  confirm(id, confirmedByName) {
    return http.post(`/api/v1/settlements/${id}/confirm`, {
      confirmed_by_name: confirmedByName,
    })
  },
  // data es un FormData: payment_method y, opcionalmente, el comprobante.
  pay(id, data) {
    return http.post(`/api/v1/settlements/${id}/pay`, data, {
      headers: {'Content-Type': 'multipart/form-data'},
    })
  },
  pendingTrips(providerId, from, to) {
    return http.get('/api/v1/settlements/pending-trips', {
      params: {provider_id: providerId, from, to},
    })
  },
  dashboard() {
    return http.get('/api/v1/settlements/dashboard')
  },
  // Estado de pago al proveedor de varios viajes, para el badge de la lista.
  tripStatus(bookingIds) {
    return http.get('/api/v1/settlements/trip-status', {
      params: {booking_ids: bookingIds.join(',')},
    })
  },
  exportUrl(id) {
    return `/api/v1/settlements/${id}/export`
  },
  // El export descarga un .xlsx: hace falta responseType blob.
  download(id) {
    return http.get(`/api/v1/settlements/${id}/export`, {responseType: 'blob'})
  },
  downloadPdf(id) {
    return http.get(`/api/v1/settlements/${id}/export-pdf`, {responseType: 'blob'})
  },
}
